export const setChartData = '@engagementLevel/setChartData';
export const setLoading = '@engagementLevel/setLoading';
export const setIsSplit = '@engagementLevel/setIsSplit';
export const setShowSharePrice = '@engagementLevel/setShowSharePrice';
export const setDataType = '@engagementLevel/setDataType';
export const setTimeRange = '@engagementLevel/setTimeRange';
export const setIsNumber = '@engagementLevel/setIsNumber';
export const setIsPercentage = '@engagementLevel/setIsPercentage';
export const setAllEngagementValue = '@engagementLevel/setAllEngagementValue';
